import React, { createContext, useState, useEffect } from "react";

// Create the context
export const UserContext = createContext();

// Create the provider component
export const UserProvider = ({ children }) => {
  // Utility function to safely parse JSON
  const parseJSON = (key) => {
    try {
      const item = sessionStorage.getItem(key);
     
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error(`Failed to parse ${key} from sessionStorage:`, error);
      return null;
    }
  };

  // State for user and email
  const [user, setUser] = useState(() => parseJSON("user"));
  const [email, setEmail] = useState(() => parseJSON("email"));
  const [isuser,setisuser]=useState(() => parseJSON("userid"));
  // Sync user state to sessionStorage whenever it changes
  useEffect(() => {
    try {
      if (user) {
        sessionStorage.setItem("user", JSON.stringify(user));
      } else {
        sessionStorage.removeItem("user");
      }
    } catch (error) {
      console.error("Failed to save user to sessionStorage:", error);
    }
  }, [user]);

  // Sync email state to sessionStorage whenever it changes
  useEffect(() => {
    try {
      if (email) {
        sessionStorage.setItem("email", JSON.stringify(email));
      } else {
        sessionStorage.removeItem("email");
      }
    } catch (error) {
      console.error("Failed to save email to sessionStorage:", error);
    }
  }, [email]);

  // Clear user and email (useful for logout)
  const clearUser = () => {
    setUser(null);
    setEmail(null);
    setisuser(null)
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("email");
    sessionStorage.removeItem("isuser");
  };

  return (
    <UserContext.Provider value={{ user, setUser, email, setEmail, clearUser,isuser,setisuser }}>
      {children}
    </UserContext.Provider>
  );
};
